import Vue from 'vue'
import Router from 'vue-router'
import HeadOne from "@/components/head/head-one"

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router)

// 公用页面
const login = () => import("@/view/login");
const dashboard = () => import("@/components/template/dashboard");

// 页面
const home = () => import("@/view/documents/index")
const list = () => import("@/view/documents/list")
const detail = () => import("@/view/documents/detail")
const blank = () => import("@/view/blank/index")

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/index"
    },
    {
      path: '/index',
      component: HeadOne,
      hidden: true,
      children: [
        {
          path: "/index",
          component: home,
          meta: {
            title: "首页"
          }
        },
      ],
    },
    {
      path: '/blank',
      component: blank,
      hidden: true,
      children: [
        {
          path: "/index",
          component: blank,
          meta: {
            title: "暂无权限"
          }
        },
      ],
    },
    {
      path: '/list',
      component: list,
      hidden: true,
      children: [
        {
          path: "/list",
          component: list,
          meta: {
            title: "列表页"
          }
        },
      ],
    },
    {
      path: '/detail',
      component: detail,
      hidden: true,
      children: [
        {
          path: "/detail/:id",
          component: detail,
          meta: {
            title: "详情"
          }
        }
      ],
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js